if (!customElements.get('wls-summary-notices-info-popup')) {
  class WLSSummaryNoticesInfoPopup extends HTMLElement {
    constructor() {
      super();
      
      // Define all element and class selectors
      this.classes = {
        button: 'js-wls-summary-notices__info-popup-button',
        popupContent: 'js-wls-summary-notices-info-popup-content',
        visibility: 'is-visible',
      }

      // Bind methods to the instance
      this.bindMethods = {
        handleClick: this._handleClick.bind(this),
      }
    }

    // Get elements
    get elements () {
      return {
        button: this.querySelector(`.${this.classes.button}`),
        popupContent: this.querySelector(`.${this.classes.popupContent}`)
      }
    }

    connectedCallback() {
      const { button } = this.elements;

      if (button) {
        button.addEventListener('click', this.bindMethods.handleClick);
      }
    }

    disconnectedCallback() {
      const { button } = this.elements;

      if (button) {
        button.removeEventListener('click', this.bindMethods.handleClick);
      }
    }

    _handleClick() {
      const { popupContent } = this.elements;

      if (popupContent) {
        popupContent.classList.toggle(this.classes.visibility);
      }
    }

  }
  customElements.define('wls-summary-notices-info-popup', WLSSummaryNoticesInfoPopup);
}
